import Cookies from 'js-cookie';

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign'];
const COOKIE_EXPIRY_DAYS = 30;

export function captureUTMParams() {
	const urlParams = new URLSearchParams(window.location.search);

	UTM_PARAMS.forEach(param => {
		const value = urlParams.get(param);
		if (value) {
			Cookies.set(param, value, {
				expires: COOKIE_EXPIRY_DAYS,
				secure: true,
				sameSite: 'Lax'
			});
		}
	});
}

export function getUTMParam(param) {
	return Cookies.get(param);
}